import { InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useTypedTheme } from "hooks";
import { palette } from "theme/palette";

export const Label = styled(InputLabel)(() => {
  const { theme } = useTypedTheme();

  const {
    typography: { h4 },
  } = theme;

  return {
    ...h4,
    marginLeft: 18,
    overflow: "visible",
    whiteSpace: "pre-wrap",
    "&.Mui-disabled ": {
      backgroundColor: palette.lightGrey,
    },
    "&.error-Border": {
      border: `1px solid ${palette.error}`,
    },
  };
});
